import { TResponse } from '@r1-frontend/do-request/core/types';
import { BaseErrorBody } from '@r1-frontend/do-request/error';
import { getErrorMessage } from '@r1-frontend/do-request/error/baseErrorBody';
import { INewsResponse, IResponseItem } from '@r1-frontend/api-domru/content-static/v2/news/dto/responseDto';

import { getFormattedNews } from '~/src/entities/formattedNews';
import { TAppThunkDispatch, TGetState } from '~/src/store';
import { setErrorNews, setNews } from '~/src/store/actionCreators/news';

interface ISetNewsResponseProps {
    prevItems: IResponseItem[],
    alias?: string,
    response: TResponse<INewsResponse, BaseErrorBody>,
}

export const setNewsResponse = ({ response, alias }: ISetNewsResponseProps) => {
    return (dispatch: TAppThunkDispatch, getState: TGetState): void => {
        const { news } = getState();
        const prevItems = news.itemsByAlias;

        if (response.isSuccess) {
            const data = getFormattedNews(response?.payload);
            const { items, pageCount, currentPage, perPage } = data || {};

            dispatch(setNews({
                fetching: false,
                items,
                itemsByAlias: alias ? items : prevItems,
                pageCount,
                currentPage,
                perPage,
            }));
            return;
        }
        dispatch(setErrorNews({
            fetching: false,
            fetchError: getErrorMessage(response),
        }));
    };
};
